<template>
  <thead class="bg-gray-50">
    <tr>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        #
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right"
      >
        {{ $t('acc_orders.creation_date') }}
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        {{ $t('acc_orders.quantity_abbreviation') }}
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        {{ $t('acc_orders.payment_method') }}
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        {{ $t('acc_orders.status') }}
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right"
      >
        {{ $t('acc_orders.shipping_total') }}
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right"
      >
        {{ $t('acc_orders.total') }}
      </th>
    </tr>
  </thead>
</template>

<script>
export default {};
</script>
